export default __webpack_public_path__ + "static/beatbugs-4-3ea5ecc72202e307d90595587b21b0b7.webp";